/**
 * @generated SignedSource<<7e4478f2544db633c06a165542c77b17>>
 * @relayHash 4e5e32f92903b0ddb3e0d216186ab7d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID db8b39ea6d26e658656d63752a19397755fa6f89a774cfd8721920766e16cd63

import type { ConcreteRequest } from 'relay-runtime';
export type NthUserHomeOnboardingRevampGetUserDataQuery$variables = Record<PropertyKey, never>;
export type NthUserHomeOnboardingRevampGetUserDataQuery$data = {
  readonly user: {
    readonly confluence: {
      readonly hasPersonalSpace: boolean | null | undefined;
      readonly space: {
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly displayName: string | null | undefined;
    readonly id: string | null | undefined;
    readonly team: string | null | undefined;
  } | null | undefined;
};
export type NthUserHomeOnboardingRevampGetUserDataQuery = {
  response: NthUserHomeOnboardingRevampGetUserDataQuery$data;
  variables: NthUserHomeOnboardingRevampGetUserDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "ScalarField",
        "name": "displayName"
      },
      {
        "kind": "ScalarField",
        "name": "team"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasPersonalSpace"
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NthUserHomeOnboardingRevampGetUserDataQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NthUserHomeOnboardingRevampGetUserDataQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4e5e32f92903b0ddb3e0d216186ab7d9",
    "id": "db8b39ea6d26e658656d63752a19397755fa6f89a774cfd8721920766e16cd63",
    "metadata": {},
    "name": "NthUserHomeOnboardingRevampGetUserDataQuery",
    "operationKind": "query",
    "text": "query NthUserHomeOnboardingRevampGetUserDataQuery{user:confluence_atlassianUser(current:true){id,displayName,team,confluence{hasPersonalSpace,space{id,key}}}}"
  }
};
})();

(node as any).hash = "851093c14fc8eb32514cb97641783e65";

export default node;
